import React from "react";
import { ValType } from "../../utils/ValidationFunctions";
import Form from "../../common/forms/Form";
import FormInput from "../../common/forms/FormInput";
import { useTranslation } from "react-i18next";
import RegistHeader from "./RegistHeader";
import styles from "./p-register.module.scss";
import formStyles from "../../common/forms/g-formInput.module.scss";
import MailNonarrival from "../../common/MailNonarrival";
import SonicLink from "../../common/routing/SonicLink";

type Props = {
  submit_handler: () => void;
  input_handler: (value: string) => void;
  verification_state?: number;
  code?: string;
};

const RegistVerificationForm: React.FC<Props> = ({
  submit_handler,
  input_handler,
  verification_state,
  code,
}) => {
  const { t } = useTranslation();
  // Hello;
  const genStateMessage = () => {
    switch (verification_state) {
      case 2:
      default:
        return (
          <FormInput
            type="verification_code"
            label="認証コードを入力"
            name="sonic_verification_code"
            val_type={ValType.NotNull}
            placeholder="認証コードを入力"
            id="sonic_verification_code"
            handler={input_handler}
            initial_value={code}
            style_class={
              verification_state == 1
                ? `${formStyles["g-form__input"]} ${formStyles["error"]}`
                : `${formStyles["g-form__input"]}`
            }
            label_class={
              verification_state == 1
                ? `${formStyles["g-form__label"]} ${formStyles["error"]}`
                : `${formStyles["g-form__label"]}`
            }
          />
        );
      case 0:
        return <div>{t("読み込み中")}</div>;
      case 1:
        return (
          <div className={styles["p-error__validation"]}>
            <div className={styles["p-error__validation__text"]}>
              {t(
                "エラーが発生しました。正しいコードを入力したことを確認してください。"
              )}
            </div>
            <div className={styles["p-error__validation__input"]}>
              <FormInput
                type="verification_code"
                label="認証コードを入力"
                name="sonic_verification_code"
                val_type={ValType.NotNull}
                placeholder="認証コードを入力"
                id="sonic_verification_code"
                handler={input_handler}
                initial_value={code}
                style_class={
                  verification_state == 1
                    ? `${formStyles["g-form__input"]} ${formStyles["error"]}`
                    : `${formStyles["g-form__input"]}`
                }
                label_class={
                  verification_state == 1
                    ? `${formStyles["g-form__label"]} ${formStyles["error"]}`
                    : `${formStyles["g-form__label"]}`
                }
              />
            </div>
          </div>
        );
    }
  };

  return (
    <div className={styles["p-register__box"]}>
      <RegistHeader
        showLogo={false}
        title={"認証コード"}
        message={"登録したメールアドレスに認証コードを送信しました"}
      />
      <MailNonarrival />
      <div className={styles["p-register__form"]}>
        <Form
          handler={submit_handler}
          button_id="next_button"
          button_text="次へ"
          button_class={formStyles["g-button"]}
        >
          <div className={formStyles["g-form__wrapper"]}>
            {genStateMessage()}
          </div>
        </Form>
        <SonicLink
          to="/verify/resend"
          className={styles["p-register__form__button"]}
        >
          認証コードを再送信
        </SonicLink>
      </div>
    </div>
  );
};

export default RegistVerificationForm;
